import { render, staticRenderFns } from "./BrowseOccupations.vue?vue&type=template&id=2f430d78&"
import script from "./BrowseOccupations.vue?vue&type=script&lang=js&"
export * from "./BrowseOccupations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports